import React from 'react';
import { Hero } from '../components/Hero';
import { WhyUs } from '../components/WhyUs';
import { ByTheNumbers } from '../components/ByTheNumbers';
import { Services } from '../components/Services';
import { HowItWorks } from '../components/HowItWorks';
import { FAQ } from '../components/FAQ';
import { Reviews } from '../components/Reviews';
import { CtaBanner } from '../components/CtaBanner';
export function Home() {
  return <main data-id="element-2727">
      <div className="dark" data-id="element-2728">
        <Hero data-id="element-2729" />
      </div>
      <WhyUs data-id="element-2730" />
      <ByTheNumbers data-id="element-2731" />
      <Services data-id="element-2732" />
      <HowItWorks data-id="element-2733" />
      <FAQ data-id="element-2734" />
      <Reviews data-id="element-2735" />
      <CtaBanner data-id="element-2736" />
    </main>;
}